import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import Card from '../../components/base/Card';

export default function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    // 하드코딩된 계정 정보
    const accounts = [
      { 
        email: 'acsakhd', 
        password: '124gasd89!@$', 
        role: 'admin',
        redirect: '/admin-dashboard'
      },
      { 
        email: 'student01', 
        password: 'student123', 
        role: 'student',
        redirect: '/student-dashboard'
      },
      { 
        email: 'superadmin', 
        password: 'super123!@#', 
        role: 'super_admin',
        redirect: '/super-admin-dashboard'
      }
    ];

    // 로그인 검증
    setTimeout(() => {
      const account = accounts.find(
        acc => acc.email === formData.email && acc.password === formData.password
      );

      if (account) {
        // 로그인 성공
        localStorage.setItem('user', JSON.stringify({
          email: formData.email,
          role: account.role
        }));
        
        setLoading(false);
        navigate(account.redirect);
      } else {
        setError('아이디 또는 비밀번호가 올바르지 않습니다.');
        setLoading(false);
      }
    }, 800);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        {/* 로고 및 타이틀 */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
            <i className="ri-shield-check-line text-3xl text-white"></i>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">CEIS</h1>
          <p className="text-gray-600">증명서 발급 관리 시스템</p>
        </div>

        {/* 로그인 카드 */}
        <Card className="shadow-xl">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">로그인</h2>
            <p className="text-gray-600">계정으로 로그인하세요</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg flex items-center gap-2">
                <i className="ri-error-warning-line"></i>
                <span className="text-sm">{error}</span>
              </div>
            )}

            <Input
              label="아이디"
              name="email"
              type="text"
              value={formData.email}
              onChange={handleChange}
              placeholder="아이디를 입력하세요"
              required
            />

            <Input
              label="비밀번호"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="비밀번호를 입력하세요"
              required
            />

            <div className="flex items-center justify-between">
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <span className="ml-2 text-sm text-gray-600">로그인 상태 유지</span>
              </label>
            </div>

            <Button type="submit" loading={loading} className="w-full">
              <i className="ri-login-circle-line"></i>
              로그인
            </Button>
          </form>
        </Card>

        {/* 푸터 */}
        <div className="mt-8 text-center text-sm text-gray-600">
          <p>&copy; 2024 CEIS. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
